import {
  ErrorMetadata,
  ForbiddenError,
  IKazooErrorConstructable,
  initializeError,
} from "@kazoohr/types";

/* eslint-disable complexity */
/*  This function has high complexity, but since it simplifies caller code, I think that's a good tradeoff. */

/**
 * Asserts that the workspace matches and throws and error if we they don't match.
 *
 * @param workspace - a string or a context
 * @param entity - something that has a "workspace" or a "subdomain"
 * @param options - used to specify a custom error
 */
export function assertWorkspaceMatches(
  workspace: string | { claim: (claimName: "workspace") => string },
  entity: {} | { workspace: string } | { subdomain: string },
  options: {
    errorMessage: string;
    errorMetadata: {} & ErrorMetadata;
    errorType?: IKazooErrorConstructable;
  } = {
    errorMessage: "Workspace does not match",
    errorMetadata: {
      workspace:
        typeof workspace === "object"
          ? workspace.claim("workspace")
          : workspace,
      entity,
    },
  }
) {
  const workspaceToTestAgainst =
    typeof workspace === "object" ? workspace.claim("workspace") : workspace;

  if ("workspace" in entity && entity.workspace != workspaceToTestAgainst) {
    throw initializeError(
      options.errorType || ForbiddenError,
      options.errorMessage,
      options.errorMetadata
    );
  }
  if ("subdomain" in entity && entity.subdomain != workspaceToTestAgainst) {
    throw initializeError(
      options.errorType || ForbiddenError,
      options.errorMessage,
      options.errorMetadata
    );
  }
}
